import {
  FiUser,
  FiHeart,
  FiBriefcase,
} from 'react-icons/fi'

export interface AudienceCategory {
  id: string
  title: string
  description: string
  idealFor: string[]
  whyValuable: string
  icon: typeof FiUser
  imagePlaceholder: string
}

export const audienceCategories: AudienceCategory[] = [
  {
    id: 'individual',
    title: 'Individuals',
    description: 'For people who want to better understand and manage their own health.',
    idealFor: [
      'Anyone trying to make sense of their health records, symptoms, or genetic data',
      'People who want clarity, structure, and guidance in their wellness journey',
      'Anyone who wants an AI wellness coach to help set goals, build habits, and track progress',
      'Individuals managing chronic conditions or working on preventive health',
    ],
    whyValuable: 'Most people have health information scattered everywhere — test results in emails, genetic reports in PDF files, bloodwork in portals, supplements scribbled somewhere else. Livewello brings everything into one organized place, gives you insights you can act on, and helps you build stronger habits with your Personal AI Wellness Coach.',
    icon: FiUser,
    imagePlaceholder: 'Individual managing health',
  },
  {
    id: 'caregiver',
    title: 'Caregivers',
    description: 'For people helping a loved one with their health.',
    idealFor: [
      'Parents managing a child\'s health',
      'Adults supporting an elderly parent',
      'Partners supporting a spouse through a diagnosis',
      'Family members keeping track of medications, symptoms, labs, or appointments',
    ],
    whyValuable: 'Caregiving is stressful because information is often scattered and communication breaks down. Livewello lets caregivers create and manage shared health records, track daily symptoms, organize medications, note observations, and share selected information with doctors, family members, or coaches — all with fine-grained permissions. Caregivers get clarity, structure, and peace of mind.',
    icon: FiHeart,
    imagePlaceholder: 'Caregiver supporting loved one',
  },
  {
    id: 'coach',
    title: 'Coaches & Wellness Practitioners',
    description: 'For professionals who support clients on their health and wellness journey.',
    idealFor: [
      'Health coaches',
      'Nutritionists',
      'Mindset and wellness practitioners',
      'Functional health professionals',
      'Trainers, therapists, and holistic practitioners',
    ],
    whyValuable: 'Livewello gives practitioners a clean, organized way to understand client history, track progress, measure outcomes, and stay aligned with client goals. You get: a shareable Personal Health Record your clients control, AI-generated summaries and insights, goal tracking and compliance monitoring, tools to showcase your impact and improve accountability, and a streamlined way to work with clients between sessions. Livewello helps practitioners do what they do best — empower transformation — while letting clients stay in control of their own data.',
    icon: FiBriefcase,
    imagePlaceholder: 'Wellness coach with client',
  },
]

export const getCategoryById = (id: string): AudienceCategory | undefined => {
  return audienceCategories.find((cat) => cat.id === id)
}





















